import { useScreenSize } from '@ltvco/refresh-lib/utils';
import { useSession } from '@ltvco/refresh-lib/v1';
import { useEffect, useState } from 'react';

export const useMobileDownloadSnackbar = () => {
  const { isMobile } = useScreenSize();
  const {
    session: { account },
  } = useSession();

  const isClosedBefore =
    (account?.account?.user_settings as any)?.hide_mobile_download_snackbar ||
    false;
  const [isLoaded, setIsLoaded] = useState(false);
  const [open, setOpen] = useState(isMobile && !isClosedBefore);

  useEffect(() => {
    const handlePageLoad = () => {
      setIsLoaded(true);
    };

    if (document.readyState === 'complete') {
      handlePageLoad();
    } else {
      window.addEventListener('load', handlePageLoad);
      return () => window.removeEventListener('load', handlePageLoad);
    }
  }, []);

  useEffect(() => {
    const handleBannerDismissed = () => {
      setOpen(false);
    };

    window.addEventListener('closedownloadbanner', handleBannerDismissed);
    return () =>
      window.removeEventListener('closedownloadbanner', handleBannerDismissed);
  }, []);

  const shouldShowSnackbar = open && isLoaded;

  const hideSnackbar = async () => {
    setOpen(false);

    try {
      const response = await fetch('/api/v5/user_settings', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          setting: 'hide_mobile_download_snackbar',
          setting_state: 'true',
        }),
      });

      if (!response.ok) {
        console.error(
          'Failed to update user setting:',
          response.status,
          response.statusText
        );
        setOpen(true);
        return;
      }
      window.dispatchEvent(new CustomEvent('closedownloadbanner'));
    } catch (error) {
      setOpen(true);
      console.error('Failed to update user setting:', error);
    }
  };

  return {
    shouldShowSnackbar,
    hideSnackbar,
    shouldShowBanner: shouldShowSnackbar,
    hideBanner: hideSnackbar,
    isLoaded,
    open,
  };
};
